import axios from "axios";

const INFINITE_SCROLL_CLASSNAME = "js-infinite-scroll";

class InfiniteScroll {
  itemPerPage = 0;
  totalItems = 0;
  currentPage = 1;
  isLoading = false;
  apiUrlPath = "";

  static infiniteScrollEndReachedEventName = "InfiniteScrollEndReached";
  static infiniteScrollDataLoadedEventName = "InfiniteScrollDataLoaded";

  static attach() {
    const $infiniteScrollElement = document.querySelector(`.${INFINITE_SCROLL_CLASSNAME}`);
    if ($infiniteScrollElement) {
      /* eslint-disable-next-line no-unused-vars */
      const infiniteScroll = new InfiniteScroll($infiniteScrollElement);
    }
  }

  constructor($infiniteScrollElement) {
    this.$infiniteScrollElement = $infiniteScrollElement;
    const { apiUrl, itemPerPage } = this.$infiniteScrollElement.dataset;
    if (itemPerPage) {
      this.itemPerPage = +itemPerPage;
    }
    if (apiUrl) {
      // GETパラメータの先頭を必ず?page=にすることでアイテム一覧ページURLをGETパラメータなしでアクセス可能にする
      let getParametersStartFromPageParameter = `?page=${this.currentPage}`;
      this.apiUrlPath = apiUrl + getParametersStartFromPageParameter;

      // apiUrlに検索フォームのGETパラメータがある場合は?page=&検索フォームのGETパラメータとなるように並び替える
      const getParametersMatchPattern = /\?.*/;
      const getParametersSearchForms = apiUrl.match(getParametersMatchPattern);
      if (getParametersSearchForms !== null) {
        const apiUrlAvoidGetParameters = apiUrl.substring(0, apiUrl.indexOf("?"));
        getParametersStartFromPageParameter = `?page=${this.currentPage}
        &${getParametersSearchForms[0]?.replace(/^\?/, "")}`;
        this.apiUrlPath = apiUrlAvoidGetParameters + getParametersStartFromPageParameter;
      }
    }

    window.addEventListener("scroll", () => {
      this.checkIsEndOfContainer();
    });
    window.addEventListener("resize", () => {
      this.checkIsEndOfContainer();
    });
    this.checkIsEndOfContainer();
  }

  loadContent() {
    const { endOfRecord } = this.$infiniteScrollElement.dataset;
    if (endOfRecord === "true") {
      return;
    }

    this.isLoading = true;
    this.showHidePreloader();
    axios({
      method: "GET",
      url: `${this.apiUrlPath}&page=${this.currentPage}`, // page=を重複して付加してるように見えるがここのpageパラメータを外すとスクロールで無限fetch
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((response) => {
        const { totalItems, itemPerPage } = response.data;
        if (itemPerPage) {
          this.itemPerPage = +itemPerPage;
        }
        if (totalItems) {
          this.totalItems = +totalItems;
        }

        document.dispatchEvent(
          new CustomEvent(InfiniteScroll.infiniteScrollDataLoadedEventName, {
            detail: {
              apiResponse: response,
              targetElement: this.$infiniteScrollElement,
              currentPage: this.currentPage
            }
          })
        );
        this.currentPage += 1;
        this.checkIsEndOfRecord(itemPerPage, totalItems);
      })
      .catch(() => {
        // NOTE: if error, silent fail and do not update any data.
      })
      .then(() => {
        this.isLoading = false;
        this.showHidePreloader();
        this.checkIsEndOfContainer();
      });
  }

  showHidePreloader() {
    this.$infiniteScrollElement.classList.toggle("is-loading", this.isLoading);
  }

  checkIsEndOfContainer() {
    const { height, top } = this.$infiniteScrollElement.getBoundingClientRect();
    const elementTop = window.scrollY + top;
    const elementBottom = elementTop + height;
    const isEndOfContainer = window.pageYOffset + window.innerHeight > elementBottom;
    if (isEndOfContainer) {
      if (!this.isLoading) {
        this.loadContent();
      }
    }
  }

  checkIsEndOfRecord(itemPerPage, totalItems) {
    if (totalItems < itemPerPage) {
      this.isLoading = false;
      this.$infiniteScrollElement.dataset.endOfRecord = "true";
    }
  }
}

export { InfiniteScroll };
